import React, { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";
import { useSeoMap, isPrivatePath } from "../lib/seo";

const BRAND = "Crunchy Sweet";
const abs = (site, u) => (!u ? "" : u.startsWith("http") ? u : u.startsWith("/api/files/") ? `${site}${u}?og=1` : `${site}${u}`);

export const Seo = ({ title, description, image, type = "website", jsonLd, noindex }) => {
  const { pathname } = useLocation();
  const map = useSeoMap();
  useEffect(() => { document.querySelectorAll("[data-pr]").forEach((el) => el.remove()); }, []);
  const site = map?.site || window.location.origin;
  const path = pathname.length > 1 ? pathname.replace(/\/+$/, "") : "/";
  const e = map?.pages?.[path];
  const full = e?.title || (title ? `${title} · ${BRAND}` : `${BRAND} · Cookies & brownies artisanaux à Palaiseau`);
  const desc = e?.description || description || "";
  const img = e?.image || abs(site, image) || `${site}/og/p-ultra.jpg`;
  const canonical = e?.canonical || `${site}${path}`;
  const lds = e?.jsonld?.length ? e.jsonld : jsonLd ? [jsonLd] : [];
  const offHost = !!map?.site && !window.location.origin.startsWith(map.site);
  const robots = noindex || isPrivatePath(path) || offHost;
  return (
    <Helmet>
      <html lang="fr" />
      <title>{full}</title>
      {desc && <meta name="description" content={desc} />}
      {!noindex && <link rel="canonical" href={canonical} />}
      {robots && <meta name="robots" content="noindex, nofollow" />}
      <meta property="og:site_name" content={BRAND} />
      <meta property="og:locale" content="fr_FR" />
      <meta property="og:title" content={full} />
      {desc && <meta property="og:description" content={desc} />}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={img} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={full} />
      {desc && <meta name="twitter:description" content={desc} />}
      <meta name="twitter:image" content={img} />
      {map?.verify?.google && <meta name="google-site-verification" content={map.verify.google} />}
      {map?.verify?.bing && <meta name="msvalidate.01" content={map.verify.bing} />}
      {lds.map((ld, i) => <script key={i} type="application/ld+json">{JSON.stringify(ld)}</script>)}
    </Helmet>
  );
};
